import { render } from "./ActivePatients.vue?vue&type=template&id=b7e1d22a&scoped=true&lang=pug"
import script from "./ActivePatients.vue?vue&type=script&lang=js"
export * from "./ActivePatients.vue?vue&type=script&lang=js"

import "./ActivePatients.vue?vue&type=style&index=0&id=b7e1d22a&scoped=true&lang=scss"
import "./ActivePatients.vue?vue&type=style&index=1&id=b7e1d22a&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7e1d22a"]])

export default __exports__